import axios from "axios";
import {
  getConfigHeader,
  refrech,
  URL_EMAIL_BY_LOGIN,
  URL_UPDATE_EMAIL,
  URL_UPDATE_PASSWWORD,
} from "./config";
import { getTokenData } from "./Auth__Service";

const qs = require("qs");

const updateEmail = async (email) => {
  const { login } = getTokenData();
  return refrech()
    .then(() =>
      axios.put(
        URL_UPDATE_EMAIL,
        qs.stringify({ login, email }),
        getConfigHeader()
      )
    )
    .catch((error) => Promise.reject(error));
};

const updatePassword = async (password, loginUser = null) => {
  const { login } = getTokenData();

  return refrech()
    .then(() =>
      axios.put(
        URL_UPDATE_PASSWWORD,
        qs.stringify({ login: loginUser ? loginUser : login, password }),
        getConfigHeader()
      )
    )
    .catch((error) => Promise.reject(error));
};

const getEmailUser = async () => {
  const { login } = getTokenData();
  return refrech()
    .then(() =>
      axios.get(
        URL_EMAIL_BY_LOGIN + "?login=" + login,
        qs.stringify({ login }),
        getConfigHeader()
      )
    )
    .catch((error) => Promise.reject(error));
};

export { updateEmail, updatePassword, getEmailUser };
